import React from 'react';
import { Tappable, TappableProps } from 'src/components/Tappable/Tappable';
import { Title3 } from 'src/components/Typography';
import useStyles from './Alert.styles';

export type AlertActionProps = TappableProps & {
  type?: 'cancel' | 'destructive' | 'regular';
};

export const AlertAction: React.FC<AlertActionProps> = ({
  children,
  type = 'regular',
  ...props
}) => {
  const s = useStyles();

  return (
    <Tappable style={s.actionIOS} {...props}>
      <Title3
        numberOfLines={1}
        style={[
          s.actionText,
          type === 'cancel' && s.actionCancel,
          type === 'destructive' && s.actionDestructive,
        ]}
      >
        {children}
      </Title3>
    </Tappable>
  );
};
